/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return true;
  }


  isPaneCollapsed ()
  {
    return true;
  }


  getSelectShape (source, galaxy)
  {
    const projectile = source.getZone().getBuilding().getConstants().getProjectileType();

    return galaxy.getConstants().getProjectile(projectile).getShape();
  }


};
